// extracted by mini-css-extract-plugin
export default {"main":"ButtonPencil_main__7duOI","icon":"ButtonPencil_icon__lmf+H"};